export default "__VITE_ASSET__CC$iKvdQ__"